export default "__VITE_ASSET__786ad3bd__"